import React from 'react';
import { FDIcon, FDPaper, FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { RichTextDisplay } from 'Packages/FacetDesign/Components';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('SecurityAlert', (theme) => ({
  root: {
    position: 'relative',
    borderRadius: '50%',
    border: `1px ${theme.palette.primary.dark} solid`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '32px',
    width: '32px',
    '& svg': {
      fontSize: '20px',
    },
  },

}));

export const SecurityAlert = ({ value }) => {
  const classes = useStyles();

  if (!value) {
    return null;
  }

  return (
    <FDPaper appearance={'flat'} color={'info'} padding={2}>
      <FDStack alignItems={'center'} spacing={1}>
        <FDStack alignItems={'center'} justifyContent={'center'}>
          <div className={classes.root}>
            <FDIcon icon={'lock'} size={'md'} />
          </div>
        </FDStack>
        <RichTextDisplay value={value} />
      </FDStack>
    </FDPaper>
  );
};

SecurityAlert.defaultProps = {
  value: null,
};

SecurityAlert.propTypes = {
  value: PropTypes.string,
};
